import { FC } from 'react'

import { StatusCard } from './StatusCard'
import { ILoadErrorPromptProps } from './types'

export const LoadErrorPrompt: FC<ILoadErrorPromptProps> = ({
  onRetry,
  isLoading = false,
}) => (
  <StatusCard
    title="Ошибка загрузки"
    description="Проверьте, пожалуйста, подключение или попробуйте обновить страницу"
    buttonText="Обновить"
    onButtonClick={onRetry}
    isButtonDisabled={isLoading}
  />
)
